/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment, useEffect, useState, useContext } from "react";
import { SimpliCityAdminSDK } from "@simplicitycms/simplicity-admin-js-sdk";
import { useAuth } from "cms/auth/hooks/use-auth";
import { isObject, objectHasPropertyString, isGuid } from "utils/empty-exists";
import { LinkSelectorWrapper } from "cms/links/link-selector/link-selector-wrapper";
import { ServiceListIconLinkContext } from "../icon-link-context";
import { cloneObjectsArray } from "utils/array/index";
import { IconSelectorView } from "./icon-selector-view";
import { LinkDisplayComponent } from "../link-display-component";
import { LinkAddComponent } from "../link-add-component";
// import { Logger } from "cms/utils/log/logger";

/**
 *
 *    This is the Service List Icon Link Editor component
 *
 *
 * */
const ServiceListIconLink = () => {

    // const { t } = useTranslation()
    const { token } = useAuth();
    const {
        list,
        item,
        index,
        // position,
        updateItems,
    } = useContext(ServiceListIconLinkContext);
    
    const link = item?.link;
    const icon = item?.icon;

    const link_guid = link?.guid;
    const [selectedLink, setSelectedLink] = useState(link);
    const [selectedIcon, setSelectedIcon] = useState(icon);

    const [loadingLink, setLoadingLink] = useState(false);

    const loadLink = async (guid) => {
        if (isGuid(guid)) {
            const __link = await SimpliCityAdminSDK.link.findOne(token, guid);
            setSelectedLink(__link);
        }
    };

    useEffect(() => {
        const load = async () => {
            if (isGuid(link_guid)) {
                setLoadingLink(true);
                await loadLink(link_guid);
                setLoadingLink(false);
            }
        };
        // load once
        if (!isObject(link) || !objectHasPropertyString(link, "guid")) {
            load();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [link_guid]);

    const onChangeLink = (link) => {
        setSelectedLink(link);
        const nextSlides = cloneObjectsArray(list);
        nextSlides[index].link = link;
        updateItems(nextSlides);
    };
    const onRemoveLink = () => {
        const link = undefined;
        setSelectedLink(link);
        const nextSlides = cloneObjectsArray(list);
        nextSlides[index].link = link;
        updateItems(nextSlides);
    };
    const onChangeIcon = async (icon) => {
        setSelectedIcon(icon);
        const next = cloneObjectsArray(list);
        next[index].icon = icon;
        updateItems(next);
    };

    const onRemoveIcon = () => {
        const icon = undefined;
        setSelectedIcon(icon);
        const next = cloneObjectsArray(list);
        next[index].icon = icon;
        updateItems(next);
    };

    if (loadingLink) {
        return (<Fragment>loading...</Fragment>);
    }

    return (
        <Fragment>
            <div className='icon-link'>
                <div className='icon-link-icon'>
                    <IconSelectorView
                        icon={selectedIcon}
                        setIcon={setSelectedIcon}
                        onChangeIcon={onChangeIcon}
                        onRemoveIcon={onRemoveIcon}
                    />
                </div>
                <div className='icon-link-link'>
                    <LinkSelectorWrapper
                        link={selectedLink}
                        setLink={setSelectedLink}
                        onLinkChange={(link) => onChangeLink(link)}
                        onLinkRemove={() => onRemoveLink()}
                        disabled={false}
                        loadingLink={loadingLink}
                        setLoadingLink={setLoadingLink}
                        AddComponent={LinkAddComponent}
                        DisplayComponent={LinkDisplayComponent}
                    />
                </div>
            </div>
        </Fragment>
    );
};

export { ServiceListIconLink }; 
